import React from 'react';
import StatusWidgetSettings from '../../../WidgetEditionPage/WidgetSettings/StatusWidgetSettings';

const etaSupportLinkEW =
  'https://support.portal.sevensenders.com/support/solutions/articles/15000010424-designing-an-embedded-widget#ETA';

const EmbeddedWidgetStatusSettings = (props) => <StatusWidgetSettings etaSupportLink={etaSupportLinkEW} {...props} />;

export default EmbeddedWidgetStatusSettings;
